var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManageOrganisation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1145_20961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.60156 24V3.3C5.60156 2.9895 5.60156 2.6675 5.68206 2.357C5.75245 2.04722 5.9083 1.76339 6.13191 1.53775C6.35552 1.3121 6.63793 1.15369 6.94706 1.0805C7.28056 1 8.74106 1 9.05156 1H17.1016C17.4121 1 17.7341 1 18.0446 1.0805C18.3543 1.15089 18.6382 1.30674 18.8638 1.53035C19.0895 1.75396 19.2479 2.03637 19.3211 2.3455C19.4016 2.6675 19.4016 2.9895 19.4016 3.3V24H5.60156Z",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00256 14.8V21.7C1.00256 22.965 2.03756 24 3.30256 24H5.60256V12.5H3.30256C2.99206 12.5 2.67006 12.5 2.35956 12.5805C2.04906 12.661 1.76156 12.8105 1.53156 13.0405C1.31306 13.259 1.16356 13.5465 1.08306 13.857C1.01814 14.1669 0.991108 14.4836 1.00256 14.8Z",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6453 9.13042C22.3354 9.0655 22.0188 9.03847 21.7023 9.04992H19.4023V23.9999H21.7023C22.3123 23.9999 22.8974 23.7576 23.3287 23.3263C23.76 22.8949 24.0023 22.3099 24.0023 21.6999V11.3499C24.0023 11.0279 24.0023 10.7174 23.9218 10.4069C23.8413 10.0964 23.6918 9.80892 23.4618 9.57892C23.2433 9.36042 22.9558 9.21092 22.6453 9.13042Z",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2012 5.6001H14.8012",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2012 10.2002H14.8012",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2012 14.7998H14.8012",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2012 19.3999H14.8012",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1145_20961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageOrganisation);
export default __webpack_public_path__ + "static/media/Manage Organisation.274f987e7f85fd620ef85a35789780fb.svg";
export { ForwardRef as ReactComponent };